/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_SubInputs */

const en_funnel_ob_daily_sub = /** @type {(inputs: Funnel_Ob_Daily_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a goal and we'll keep you on track. Change it anytime.`)
};

const es_funnel_ob_daily_sub = /** @type {(inputs: Funnel_Ob_Daily_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un objetivo y te mantenemos al día. Puedes cambiarlo cuando quieras.`)
};

/**
* | output |
* | --- |
* | "Pick a goal and we'll keep you on track. Change it anytime." |
*
* @param {Funnel_Ob_Daily_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_sub = /** @type {((inputs?: Funnel_Ob_Daily_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_sub(inputs)
	return en_funnel_ob_daily_sub(inputs)
});